import { initializeApp } from "firebase/app";
import { getFirestore, type Firestore } from "firebase/firestore";

// Firebase configuration
const firebaseConfig = {
  // You'll need to add your Firebase config here
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Validate Firebase configuration
const validateFirebaseConfig = () => {
  const requiredFields = [
    "apiKey",
    "authDomain",
    "projectId",
    "storageBucket",
    "messagingSenderId",
    "appId",
  ] as const;

  const missingFields = requiredFields.filter(
    (field) => !firebaseConfig[field]
  );

  if (missingFields.length > 0) {
    console.error(
      "❌ Missing Firebase configuration fields:",
      missingFields.join(", ")
    );
    throw new Error(
      `Firebase configuration incomplete. Missing: ${missingFields.join(", ")}`
    );
  }
};

// Initialize Firebase
let app;
let db: Firestore;

try {
  validateFirebaseConfig();
  app = initializeApp(firebaseConfig);
  db = getFirestore(app);
} catch (error) {
  console.error("❌ Firebase initialization failed:", error);
  throw error;
}

// Initialize Firestore
export { db };

export default app;
